import { MinimalRegisterForm } from '../models/register.model';
import * as register from '../actions/register';

export interface State {
  error: null;
  form: MinimalRegisterForm;
  pending: boolean;
  success: boolean;
}

export const initialState: State = {
  error: null,
  pending: false,
  form: {email: '', password: '', confirm_password: ''},
  success: false,
};


export function reducer(state = initialState, action: register.Actions): State {
  switch (action.type) {
    case register.REGISTER: {
      return {
        ...state,
        pending: true,
        form: action.payload,
      };
    }
    case register.REGISTER_FAILURE: {
      return {
        ...state,
        error: action.payload,
        pending: false,
        success: false,
      };
    }

    case register.REGISTER_SUCCESS: {
      return {
        ...state,
        pending: false,
        error: null,
        success: true
      };
    }

    default: {
      return state;
    }
  }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getForm = (state: State) => state.form;
export const getSuccess = (state: State) => state.success;



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/reducers/register-email.ts